export enum SubscriptionStatus {
    SUB_NEAR_END = 'subscription_near_end',
    SUB_ENDED = 'subscription_ended',
    SUB_OK = 'subscription_ok',
}
